var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1621 16.0489C25.4688 13.8506 23.8839 12.7769 21.6855 12.01L22.4013 9.19815L20.663 8.73802L19.9984 11.4988L18.5669 11.1409L19.2826 8.38014L17.4933 7.92001L16.8286 10.783L15.7039 10.5274L13.301 9.9139L12.892 11.7544L14.119 12.0612C14.8347 12.2657 14.9881 12.7769 14.8859 13.1348L14.119 16.3557L12.9942 20.9059C12.892 21.1615 12.6875 21.4682 12.1762 21.3149L10.9492 21.0081L10.0801 23.002L13.5566 23.8711L12.892 26.7853L14.5791 27.1943L15.2949 24.3824L16.6241 24.6891L15.9595 27.501L17.6978 27.9612L18.4135 25.0981C21.3788 25.6605 23.6283 25.4049 24.5486 22.7464C25.2643 20.5991 24.4974 19.3721 22.9125 18.5541C24.0373 18.2985 24.9064 17.5316 25.1621 16.0489ZM21.2254 21.5705C20.663 23.6666 17.0331 22.593 15.8572 22.2862L16.8286 18.4518C18.0045 18.7586 21.7878 19.321 21.2254 21.5705ZM21.6855 15.9467C21.2254 17.9406 18.2601 16.9692 17.2376 16.7136L18.1068 13.2371C19.1293 13.4927 22.2479 13.9528 21.6855 15.9467Z",
    fill: "#22254A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtc);
export default __webpack_public_path__ + "static/media/btc.255da788567c9a64a80a88a7b42917ac.svg";
export { ForwardRef as ReactComponent };